function ExternalLinkIcon({ ...rest }) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M12.3333 8.80604V13.1394C12.3333 13.5225 12.1812 13.8899 11.9103 14.1608C11.6394 14.4316 11.272 14.5838 10.8889 14.5838H2.94444C2.56135 14.5838 2.19395 14.4316 1.92307 14.1608C1.65218 13.8899 1.5 13.5225 1.5 13.1394V5.19493C1.5 4.81184 1.65218 4.44444 1.92307 4.17356C2.19395 3.90267 2.56135 3.75049 2.94444 3.75049H7.27778'
        stroke='#B6B6B6'
        strokeWidth='2.275'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.167 1.58398H14.5003V5.91732'
        stroke='#B6B6B6'
        strokeWidth='2.275'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.55566 9.52843L14.5001 1.58398'
        stroke='#B6B6B6'
        strokeWidth='2.275'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default ExternalLinkIcon;
